import { api } from "../../../../utility/AxiosInceptor";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import "./css/plan_configuration.css";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useRef } from "react";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from "primereact/multiselect";
const featureOptions = [
  {
    label: "3 Way Calling",
  },
  {
    label: "WI-FI Calling",
  },
  {
    label: "International Roaming",
  },
  {
    label: "Tethering Block",
  },
  {
    label: "5G Compatibility",
  },
];
const validationSchema = Yup.object().shape({
  name: Yup.string().required("This is Required"),
  description: Yup.string().required("This is Required"),
  dataAllowance: Yup.number()
    .integer("Please enter a valid integer")
    .required("This is Required "),
  voiceAllowance: Yup.number()
    .integer("Please enter a valid integer")
    .required("This is Required"),
  textAllowance: Yup.number()
    .integer("Please enter a valid integer")
    .required("This is Required"),
  duration: Yup.number()
    .integer("Please enter a valid integer")
    .required("This is Required"),
  price: Yup.number().required("This is Required"),
  planId: Yup.string().required("This is Required"),
  type: Yup.string().required("This is Required"),
  carrier: Yup.string().required("This is Required"),

  durationUnit: Yup.string().required("This is Required"),
  inventoryType: Yup.string().required("This is Required"),
  makeModel: Yup.string().required("This is Required"),
});

export default function PlansConfigurations({
  data,
  isSimilarPlan,
  setAddPlanVisibility,
  setRefresh,
}) {
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  const [carrier, setCarrier] = useState(null);
  const [currentBillingId, setCurrentBillingId] = useState("");
  const toast = useRef(null);
  const [inventoryTypeOptions, setInventoryTypeOptions] = useState([]);
  const [billingModelOptions, setBillingModelOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getBillingModelList = async () => {
    try {
      const res = await api.get(
        `/api/billingModel/all?serviceProvider=${parseLoginRes?.company}`,
      );
      setBillingModelOptions(res?.data?.data || []);
      const billingmodel = res?.data?.data;
      const match = billingmodel?.find(
        (item) => item.billingModel === formik.values.type,
      );
      const id = match?._id;

      setCurrentBillingId(id);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Plan Updation",
        detail: error?.response?.data?.msg,
      });
    }
  };

  const isUnlimitedOptions = [
    {
      label: "Voice",
    },
    {
      label: "Text",
    },
    { label: "Data" },
  ];
  const durationUnitOptions = [
    {
      label: "Days",
      value: "days",
    },
  ];

  const formik = useFormik({
    initialValues: {
      name: "",
      createdBy: parseLoginRes?._id ?? "",
      serviceProvider: parseLoginRes?.company ?? "",
      description: "",
      carrier: "",
      type: "",
      durationUnit: "",
      dataAllowance: "",
      voiceAllowance: "",
      textAllowance: "",
      duration: "",
      price: "",
      planFeature: [],
      isUnlimited: [],
      makeModel: "",
      planId: "",
      additionalFeatures: ["calls", "minutes"],
      termsAndConditions: "no termsAndConditions",
      restrictions: ["no restriction"],
      inventoryType: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setIsLoading(true);
      let selectedFeatures = [];
      featureOptions.forEach((item) => {
        let obj = {
          name: item?.label,
          isSelected: formik.values.planFeature.includes(item?.label)
            ? true
            : false,
        };
        selectedFeatures.push(obj);
      });
      let make = formik.values.makeModel.substring(
        0,
        formik.values.makeModel.indexOf("-") - 1,
      );
      let model = formik.values.makeModel.substring(
        formik.values.makeModel.lastIndexOf("-") + 2,
      );
      let dataTosend = {
        ...formik.values,
        planFeature: selectedFeatures,
        make: make,
        model: model,
      };
      delete dataTosend.makeModel;

      api
        .post(`/api/web/plan`, dataTosend)
        .then(() => {
          setIsLoading(false);
          toast.current.show({
            severity: "success",
            summary: "Plan Submission",
            detail: "Plan Added Successfully",
          });
          setTimeout(() => {
            setAddPlanVisibility(false);
            setRefresh((prev) => !prev);
          }, 2000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Plan Submission",
            detail: err?.response?.data?.msg,
          });
        });
    },
  });
  useEffect(() => {
    getBillingModelList();

    if (!isSimilarPlan) return;

    const {
      _id,
      __v,
      deviceModel,
      make,
      dataAllowanceUnit,
      voiceAllowanceUnit,
      textAllowanceUnit,
      active,
      planFeature,
      ...rest
    } = data;

    const makeModel = `${make} - ${deviceModel}`;
    const Features = planFeature?.map((item) => item.name) || [];

    formik.setValues({
      ...rest,
      planFeature: Features,
      makeModel,
      additionalFeatures: ["calls", "minutes"],
      termsAndConditions: "no termsAndConditions",
      restrictions: ["no restriction"],
      createdBy: parseLoginRes?._id ?? "",
      serviceProvider: parseLoginRes?.company ?? "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (formik.values.type !== "") {
        try {
          const res = await api.get(
            `/api/billingModel/getInventoryByBillingModel?billingModel=${currentBillingId}`,
          );
          let obj = [];
          let data = res?.data?.data;
          data.forEach((item) => {
            let obj2 = {};
            obj2.inventoryType = item;
            obj.push(obj2);
          });
          setInventoryTypeOptions(obj);
        } catch (error) {
          //toast.error(error?.response?.data?.msg);
        }
      }
    }
    fetchData();
  }, [currentBillingId, formik.values.type]);

  const [makeModelOptions, setMakeModelOptions] = useState();
  useEffect(() => {
    if (formik.values.inventoryType !== "" && currentBillingId !== "") {
      api
        .get(
          `/api/inventoryType/getInventoryTypeData?inventoryType=${formik.values.inventoryType}&billingModel=${currentBillingId}&serviceProvider=${parseLoginRes?.company}`,
        )
        .then((res) => {
          let Data = res?.data?.data;
          let dataNew = [];
          for (let i = 0; i < Data.length; i++) {
            let data = Data[i];
            data.makemodel = `${data.make} - ${data.model}`;
            dataNew.push(data);
          }
          setMakeModelOptions(dataNew);
        })
        .catch((err) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBillingId, formik.values.inventoryType]);

  //     api.get(`/api/web/carrier/all`)
  //         .then((res) => {
  //             let carrierholder = [];
  //             for (let i = 0; i < res.data.data.length; i++) {
  //                 const obj = {};
  //                 obj.label = res.data.data[i].name;
  //                 obj.value = res.data.data[i]._id;
  //                 carrierholder.push(obj);
  //             }
  //             if (carrierholder.length === 1) {
  //                 formik.setFieldValue("carrier", carrierholder[0].value);
  //             }
  //             setCarrier(carrierholder);
  //         })
  //         .catch(() => {});
  // }, []);
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = res.data.data[i]._id;
          carrierholder.push(obj);
        }
        setCarrier(carrierholder); // Set the carrier options
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    if (isSimilarPlan && billingModelOptions) {
      const id = billingModelOptions.find(
        (item) => item.billingModel === data.type,
      )?._id;
      setCurrentBillingId(id);
      formik.setFieldValue("type", data.type);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingModelOptions]);
  return (
    <div className="addplanmain">
      <div className="addplandata">
        <div
          className="go-back-btn"
          onClick={() => {
            setAddPlanVisibility(false);
          }}
        >
          <i
            className="go-back pi pi-angle-left "
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="planmainheader" style={{ marginTop: "1.6rem" }}>
          <label>Add Plan</label>
          <p>
            Add a plan card by defining its details and key specifications to
            ensure accurate setup.
          </p>{" "}
        </div>
        <form onSubmit={formik.handleSubmit} className="mainaddplanform">
          <div className="addplanfield w-full">
            <div
              className="flex justify-content-between"
              style={{ width: "30rem" }}
            >
              <label>
                Billing Model <span className="steric">*</span>
              </label>
              {formik.touched.type && formik.errors.type ? (
                <p className="p-error">{formik.errors.type}</p>
              ) : null}
            </div>
            <Dropdown
              className={
                formik.touched.type && formik.errors.type
                  ? "error calendar_field"
                  : "calendar_field"
              }
              placeholder="Plan Type"
              options={billingModelOptions}
              optionLabel="billingModel"
              optionValue="billingModel"
              name="type"
              value={formik.values.type}
              onChange={(e) => {
                formik.setFieldValue("type", e.value);
                formik.setFieldValue("invetoryType", "");
                const id = billingModelOptions.find(
                  (item) => item.billingModel === e.value,
                )?._id;
                setCurrentBillingId(id);
              }}
            />
          </div>
          <div className="inventorydetails">
            <h5> Add Inventory Details</h5>
            <div style={{ marginTop: "1.2rem" }}>
              <div className="flex" style={{ gap: "1.2rem" }}>
                <div className="addplanfield mt-0">
                  <div className="flex justify-content-between">
                    <label>
                      Plan Inventory Type <span className="steric">*</span>
                    </label>
                    {formik.touched.inventoryType &&
                    formik.errors.inventoryType ? (
                      <p className="p-error">{formik.errors.inventoryType}</p>
                    ) : null}
                  </div>
                  <Dropdown
                    placeholder="Plan Inventory Type"
                    options={inventoryTypeOptions}
                    optionLabel="inventoryType"
                    optionValue="inventoryType"
                    className={
                      formik.touched.inventoryType &&
                      formik.errors.inventoryType
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="inventoryType"
                    value={formik.values.inventoryType}
                    onChange={(e) => {
                      formik.setFieldValue("makeModel", "");
                      formik.setFieldValue("inventoryType", e.value);
                    }}
                  />
                </div>
                <div className="addplanfield mt-0 ">
                  <div className="flex justify-content-between">
                    <label className="block">Make And Model</label>
                    {formik.touched.makeModel && formik.errors.makeModel ? (
                      <p className="p-error">{formik.errors.makeModel}</p>
                    ) : null}
                  </div>
                  <Dropdown
                    optionLabel="makemodel"
                    optionValue="makemodel"
                    value={formik.values.makeModel}
                    name="makeModel"
                    options={makeModelOptions}
                    onChange={formik.handleChange}
                    placeholder="Select an option"
                    className={
                      formik.touched.makeModel && formik.errors.makeModel
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                  />
                </div>
                <div className="addplanfield mt-0">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Carrier <span className="steric">*</span>
                    </label>
                    {formik.touched.carrier && formik.errors.carrier ? (
                      <p className="p-error">{formik.errors.carrier}</p>
                    ) : null}
                  </div>
                  <Dropdown
                    value={formik.values.carrier}
                    options={carrier}
                    optionLabel="label"
                    name="carrier"
                    optionValue="value"
                    onChange={formik.handleChange}
                    placeholder="Select an option"
                    className={
                      formik.touched.carrier && formik.errors.carrier
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                  />
                </div>
              </div>
              <div className="flex" style={{ gap: "1.2rem" }}>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Name <span className="steric">*</span>
                    </label>
                    {formik.touched.name && formik.errors.name ? (
                      <p className="p-error">{formik.errors.name}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan Name"
                    className={
                      formik.touched.name && formik.errors.name
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="name"
                    value={formik.values.name}
                    onChange={(e) => {
                      formik.setFieldValue(
                        "name",
                        capitalizeFirstLetter(e.target.value),
                      );
                    }}
                  />
                </div>

                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan ID <span className="steric">*</span>
                    </label>
                    {formik.touched.planId && formik.errors.planId ? (
                      <p className="p-error">{formik.errors.planId}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan ID"
                    className={
                      formik.touched.planId && formik.errors.planId
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="planId"
                    value={formik.values.planId}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="addplanfield ">
                  <label className="block">Unlimited</label>

                  <MultiSelect
                    className="calendar_field"
                    placeholder="Select Unlimited"
                    optionLabel="label"
                    options={isUnlimitedOptions}
                    optionValue="label"
                    name="isUnlimited"
                    onChange={formik.handleChange}
                    value={formik.values.isUnlimited}
                  />
                </div>
              </div>
              <div className="flex" style={{ gap: "1.2rem" }}>
                <div className="addplanfield ">
                  <label className="block">Features</label>

                  <MultiSelect
                    className="calendar_field"
                    placeholder="Select Features"
                    optionLabel="label"
                    options={featureOptions}
                    optionValue="label"
                    name="planFeature"
                    onChange={formik.handleChange}
                    value={formik.values.planFeature}
                  />
                </div>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Data Allowance <span className="steric">*</span>
                    </label>
                    {formik.touched.dataAllowance &&
                    formik.errors.dataAllowance ? (
                      <p className="p-error">{formik.errors.dataAllowance}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan Data Allowance"
                    keyfilter="int"
                    className={
                      formik.touched.dataAllowance &&
                      formik.errors.dataAllowance
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="dataAllowance"
                    value={formik.values.dataAllowance}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Voice Allowance <span className="steric">*</span>
                    </label>
                    {formik.touched.voiceAllowance &&
                    formik.errors.voiceAllowance ? (
                      <p className="p-error">{formik.errors.voiceAllowance}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan Voice Allowance"
                    keyfilter="int"
                    className={
                      formik.touched.voiceAllowance &&
                      formik.errors.voiceAllowance
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="voiceAllowance"
                    value={formik.values.voiceAllowance}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="flex " style={{ gap: "1.2rem" }}>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Text Allowance <span className="steric">*</span>
                    </label>
                    {formik.touched.textAllowance &&
                    formik.errors.textAllowance ? (
                      <p className="p-error">{formik.errors.textAllowance}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan Text Allowance"
                    keyfilter="int"
                    className={
                      formik.touched.textAllowance &&
                      formik.errors.textAllowance
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="textAllowance"
                    value={formik.values.textAllowance}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Duration Unit <span className="steric">*</span>
                    </label>
                    {formik.touched.durationUnit &&
                    formik.errors.durationUnit ? (
                      <p className="p-error">{formik.errors.durationUnit}</p>
                    ) : null}
                  </div>

                  <Dropdown
                    options={durationUnitOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Duration Unit"
                    className={
                      formik.touched.durationUnit && formik.errors.durationUnit
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="durationUnit"
                    value={formik.values.durationUnit}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Duration <span className="steric">*</span>
                    </label>
                    {formik.touched.duration && formik.errors.duration ? (
                      <p className="p-error">{formik.errors.duration}</p>
                    ) : null}
                  </div>
                  <InputText
                    placeholder="Plan Duration"
                    keyfilter="int"
                    className={
                      formik.touched.duration && formik.errors.duration
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="duration"
                    value={formik.values.duration}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="flex" style={{ gap: "1.2rem" }}>
                <div className="addplanfield ">
                  <div className="flex justify-content-between">
                    <label className="block">
                      Plan Price <span className="steric">*</span>
                    </label>
                    {formik.touched.price && formik.errors.price ? (
                      <p className="p-error">{formik.errors.price}</p>
                    ) : null}
                  </div>

                  <InputText
                    placeholder="Plan Price"
                    keyfilter="num"
                    className={
                      formik.touched.price && formik.errors.price
                        ? "error calendar_field"
                        : "calendar_field"
                    }
                    name="price"
                    value={formik.values.price}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="addplanfield " style={{ marginTop: "1.6rem" }}>
                <div
                  className="flex justify-content-between"
                  style={{ width: "61.2rem" }}
                >
                  <label className="block">
                    Plan Description <span className="steric">*</span>
                  </label>
                  {formik.touched.description && formik.errors.description ? (
                    <p className="p-error">{formik.errors.description}</p>
                  ) : null}
                </div>

                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "61.2rem",
                    height: "15rem",
                  }}
                >
                  <InputTextarea
                    placeholder="Plan Description"
                    name="description"
                    value={formik.values.description}
                    onChange={(e) => formik.handleChange(e)}
                    maxLength={200}
                    className={
                      formik.touched.description && formik.errors.description
                        ? "textareaplanerror"
                        : "textareaplan"
                    }
                    style={{
                      width: "100%",
                      paddingBottom: "2.5rem",
                      resize: "none",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "2rem",
                      right: "1rem",
                      fontSize: "1.2rem",
                      color: "#666",
                    }}
                  >
                    {200 - formik.values.description.length}/200
                  </span>
                </div>
                {/* <InputText placeholder="Plan Description" className="calendar_field" name="description" value={formik.values.description} onChange={formik.handleChange} /> */}
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="addplanbtn">
        <Button
          onClick={() => {
            setAddPlanVisibility(false);
          }}
          disabled={isLoading}
          className=" backbtn"
          label="Cancel"
          type="button"
          style={{ width: "16rem", height: "5rem" }}
        />
        <Button
          onClick={formik.handleSubmit}
          loading={isLoading}
          disabled={isLoading}
          className=" nextbtn"
          label="Add Plan"
          type="Submit"
          style={{ width: "16rem", height: "5rem" }}
        />
      </div>
      <Toast ref={toast} />
    </div>
  );
}
function capitalizeFirstLetter(string) {
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
